/** Sprint contracts — spec §6.12, §7.7a, F17. */
import { z } from 'zod';
import { SPRINT_STATUSES } from './enums.js';
export const createSprintSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    goal: z.string().max(500).optional(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
})
    .strict()
    .superRefine((val, ctx) => {
    if (val.endDate <= val.startDate) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['endDate'],
            message: 'Sprint end date must be after the start date',
        });
    }
});
export const updateSprintSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    goal: z.string().max(500).nullish(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
})
    .strict()
    .partial();
export const closeSprintSchema = z
    .object({ incompleteTo: z.enum(['next', 'backlog']).default('next') })
    .strict();
export const listSprintsQuerySchema = z
    .object({ status: z.enum(SPRINT_STATUSES).optional() })
    .strict();
//# sourceMappingURL=sprint.js.map